
import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Button,
    message,
    Typography,
    Modal
} from "../../ui/ot";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { OverdueProcessingTable } from "./overdue_processing"
const UnsuspendModal = ({
    canUnsuspend = false,
    propsIssueCardnumber = null,
    propsOnClose = () => { },
    propsButtonText = "",
    propsUnsuspend = () => { }
}) => {
    const [open, setOpen] = useState(false)

    return <>
        <Button
            type="link"
            onClick={() => {
                setOpen(true)
            }} >
            {propsButtonText}
        </Button>

        <Modal
            title
            open={open}
            close={true}
            onClose={() => {
                propsOnClose()
                setOpen(false)
            }}
            okText="OK"
            cancelText="Cancel"
            closeText="關閉"
            width={canUnsuspend ? 800 : 1600}
            confirmLoading={false}
            footer={<>
                {canUnsuspend && <Col>
                    <Button onClick={propsUnsuspend}>
                        取消停權
                    </Button>
                </Col>}
                <Col>
                    <Button variant="secondary"
                        onClick={() => {
                            setOpen(false)
                        }}
                    >
                        關閉
                    </Button>
                </Col>
            </>}
        >
            <Row gutter={[8, 8]}>
                <Col span={24}>

                </Col>
                {canUnsuspend ?
                    <Col span={24}>
                        <Typography.P>目前沒有逾期書籍紀錄，是否要進一步處理解除停權？</Typography.P>
                    </Col>
                    :
                    <Col span={24}>
                        {open && <OverdueProcessingTable
                            propsIssueCardnumber={propsIssueCardnumber}
                            propsIssueDaysDueStatus="已逾期"
                            showReturn={true}
                            onChange={() => {
                                propsOnClose()
                            }}
                        />}
                    </Col>}
            </Row>
        </Modal>
    </>
}
export default UnsuspendModal